import { useState,useRef,useEffect } from "react";
import { Modal } from 'antd';
import { GithubPicker } from 'react-color';
import { mixGetV1, mixPutV1, mixPutV2,mixGetImage } from "services/mixin";

interface Profile {
    info: {
        avatar?: File
        fullname: string
        email: string
        first_name: string
        last_name: string
        avatar_bg?: string
    }
}
const Profile = () => {
    const [isModalEditOpen, setIsModalEditOpen] = useState(false);
    const [isModalChangeName, setIsModalChangeName] = useState(false);
    const [selectedAvt, setSelectedAvt] = useState('');
    const [profile, setProfile] = useState<Profile | null>(null)
    // const [profile, setProfile] = useState(null)

    const [tempName, setTempName] = useState('')
    const [file, setFile] = useState<File | null>(null)
    const btnGroupRef = useRef<HTMLDivElement | null>(null)
    const currentAvtType = localStorage.getItem('setAvt')

    const showModalEdit = () => {
        setIsModalEditOpen(true);
    };

    const handleCancelEdit = () => {
        setIsModalEditOpen(false);
        setSelectedAvt('')
    };
    const showModalChangeName = () => {
        setIsModalChangeName(true);
    };

    const handleCancelChangeName = () => {
        setTempName(profile?.info.fullname || '')
        console.log(tempName)
        setIsModalChangeName(false);
    };

// UPLOAD HINH ANH
        const [fileError, setFileError] = useState(false);
        const [fileName, setFileName] = useState('');
        const inputRef = useRef(null);

        const handleUploadClick = () => {
            // Mở hộp chọn file
            inputRef.current?.click();
        };

        const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const file = e.target.files?.[0];
            if (!file) return;

            if (file.size > 1024 * 1024) {
                // file > 1MB
                setFileError(true);
                setFileName('');
                setFile(null)
                e.target.value = ''; // reset input
            } else {
                // file hợp lệ
                setFileError(false);
                setFile(file)
                setFileName(file.name);
            }
        };

// DOI MAU AVATAR
    const [colorAvt, setColorAvt] = useState('')

    const colors = [
        '#475E81', '#7B6FE3', '#82766E',
        '#C1187B', '#EA1823', '#F36C13',
        '#187656', '#327A9B'
    ];
    const handleChange = (color) => {
        setColorAvt(color.hex);
    };

    // useEffect(() => {
    //     const handleClickOutside = (event: MouseEvent) => {
    //         if (btnGroupRef.current && !btnGroupRef.current.contains(event.target as Node)) {
    //         // 👇 Nếu click ngoài vùng btn-group
    //         setSelectedAvt('')
    //         }
    //     }

    //     document.addEventListener('mousedown', handleClickOutside)

    //     return () => {
    //         document.removeEventListener('mousedown', handleClickOutside)
    //     }
    // }, [])

// API
    const getProfile = async () => {
        const res = await mixGetV1('/api/v1/fe/customer/profile')

        if(res.status) {
            setProfile(res.data)
            setColorAvt(res.data.info.avatar_bg ?? '#475E81')
            setTempName(res.data.info.fullname)
        }
    }
    useEffect(() => {
        getProfile()
    }, [])
    const ChangeName = async () => {
        const param = {
            fullname: tempName
        }
        try{
            const res = await mixPutV1('/api/v1/fe/customer/update',param)
            if(res.status) {
                setProfile({
                    ...profile,
                    info: {
                        ...profile?.info,
                        fullname: tempName,
                        email: profile?.info.email || '',
                        first_name: profile?.info.first_name || '',
                        last_name: profile?.info.last_name || '',
                        avatar_bg: profile?.info.avatar_bg,
                        avatar: profile?.info.avatar,

                    },
                })
                console.log('Thanh cong')
                handleCancelChangeName()
            } else {
                console.log(res.msg || 'That bai')
            }
        } catch(error) {
            console.error('Lỗi khi cập nhật tên:', error)
        }
    }

    const updateAvatar = async () => {
        try {
            if( selectedAvt === 'color') {
                const param = {
                    avatar_bg: colorAvt
                }
                const res = await mixPutV1('/api/v1/fe/customer/update',param)
                if(res.status) {
                    setProfile({
                        ...profile,
                        info: {
                            ...profile?.info,
                            fullname: profile?.info.fullname || '',
                            email: profile?.info.email || '',
                            first_name: profile?.info.first_name || '',
                            last_name: profile?.info.last_name || '',
                            avatar_bg: colorAvt,
                            avatar: profile?.info.avatar,
                        },
                    })
                    localStorage.setItem('setAvt', 'color');
                    window.location.reload()
                    handleCancelEdit()
                } else {
                    console.log(res.msg || 'That bai')
                }
            }
            if( selectedAvt === 'image') {
                if (!file) return alert('Vui lòng chọn ảnh trước!')
                const param = {
                    avatar: file
                }
                const res = await mixPutV2('/api/v1/fe/customer/update',param)
                if(res.status) {
                    setProfile({
                        ...profile,
                        info: {
                            ...profile?.info,
                            fullname: profile?.info.fullname || '',
                            email: profile?.info.email || '',
                            first_name: profile?.info.first_name || '',
                            last_name: profile?.info.last_name || '',
                            avatar_bg: profile?.info.avatar_bg || '',
                            avatar: file,
                        },
                    })
                    localStorage.setItem('setAvt', 'img');
                    window.location.reload()
                    handleCancelEdit()
                } else {
                    console.log(res.msg || 'That bai')
                }
            }
        }  catch(error) {
            console.error('Lỗi khi doi avt:', error)
        }
    }

    // useEffect(() => {
    //     if (profile) {
    //     console.log('✅ Profile khi vừa vào trang:', profile)
    //      console.log(profile?.info.avatar)
    //     }
    // }, [profile])
    useEffect(() => {
        if (isModalChangeName) {
            setTempName(profile?.info.fullname || '')
        }
    }, [isModalChangeName])


    return(
        <section className="card" id='profile'>
            <div className="card-header">
                <div className="left">
                    <div className="avatar">
                        {profile?.info.avatar === null || profile?.info.avatar === '' || currentAvtType === 'color' ? (
                            <div className="avatar-content" style={{ backgroundColor: colorAvt}}>
                                <span>{ profile?.info.fullname?.charAt(0).toUpperCase() }</span>
                            </div>
                        ):(
                            <img 
                                style={{
                                    objectFit: 'cover',
                                    height: '100%'
                                }}
                                src={mixGetImage(`/${profile?.info.avatar}`)}
                                alt="avt" 
                            />
                        )}
                        <div onClick={showModalEdit} className="btn-edit">
                                <svg
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                    d="M13.26 3.59997L5.04997 12.29C4.73997 12.62 4.43997 13.27 4.37997 13.72L4.00997 16.96C3.87997 18.13 4.71997 18.93 5.87997 18.73L9.09997 18.18C9.54997 18.1 10.18 17.77 10.49 17.43L18.7 8.73997C20.12 7.23997 20.76 5.52997 18.55 3.43997C16.35 1.36997 14.68 2.09997 13.26 3.59997Z"
                                    strokeWidth="2"
                                    strokeLinejoin="round"
                                    strokeLinecap="round"
                                    strokeMiterlimit="10"
                                    stroke="currentColor"
                                    ></path>
                                    <path
                                    d="M11.89 5.05005C12.32 7.81005 14.56 9.92005 17.34 10.2"
                                    strokeWidth="2"
                                    strokeLinejoin="round"
                                    strokeLinecap="round"
                                    strokeMiterlimit="10"
                                    stroke="currentColor"
                                    ></path>
                                    <path
                                    d="M3 22H21"
                                    strokeWidth="2"
                                    strokeLinejoin="round"
                                    strokeLinecap="round"
                                    strokeMiterlimit="10"
                                    stroke="currentColor"
                                    ></path>
                                </svg>
                            <p>Edit</p>
                        </div>
                    </div>
                    <div className="context">
                        <p className="name">{ profile?.info.fullname }</p>
                        <p className="email">{ profile?.info.email }</p>
                    </div>
                </div>
                <div className="right">
                    <p onClick={showModalEdit} className="link">Edit</p>
                </div>
            </div>
            <div className="card-detail">
                <div className="row">
                    <p className="label">User Name</p>
                    <p className="value">{ profile?.info.fullname }</p>
                    <div onClick={showModalChangeName} className="link">Change</div>
                </div>
                <div className="row">
                    <p className="label">Email Address</p>
                    <p className="value">{ profile?.info.email }</p>
                </div>
            </div>
            <Modal
                title='Profile Image'
                open={isModalEditOpen}
                onCancel={handleCancelEdit}
                className="modal-edit-profile"
                footer={null}
                width={360}
            >
                <div className="content">
                    <div className="avatar">
                        {/* {profile?.info.avatar === null ? (
                            <div className="avatar-content" style={{ backgroundColor: colorAvt}}>
                                <span>{ profile?.info.fullname?.charAt(0).toUpperCase() }</span>
                            </div>
                        ):(
                            <img 
                                style={{
                                    objectFit: 'cover',
                                    height: '100%'
                                }}
                                src={mixGetImage(`/${profile?.info.avatar}`)}
                                alt="avt" 
                            />
                        )} */}
                        {profile?.info.avatar === null || profile?.info.avatar === '' || currentAvtType === 'color' ? (
                            <div className="avatar-content" style={{ 
                                    backgroundColor: colorAvt,
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <span>{ profile?.info.fullname?.charAt(0).toUpperCase() }</span>
                            </div>
                        ):(
                            <img 
                                style={{
                                    objectFit: 'cover',
                                    height: '100%'
                                }}
                                src={mixGetImage(`/${profile?.info.avatar}`)}
                                alt="avt" 
                            />
                        )}
                    </div>
                    <p className="name">{ profile?.info.fullname }</p>
                    <div ref={btnGroupRef} className="btn-group">
                        <div onClick={()=> setSelectedAvt('image')} className="btn">Image</div>
                        <div onClick={()=> setSelectedAvt('color')} className="btn">Color</div>
                        {selectedAvt === 'image' && (
                                <div 
                                    className={`upload-box ${fileError ? 'error' : ''}`}
                                    onClick={handleUploadClick}
                                >
                                    <span className="upload-placeholder">
                                        {fileName || 'JPEG, PNG (<1MB)'}
                                    </span>
                                    <label className="upload-button">
                                        <span>Add</span>
                                        <svg fill="#475E81" height="16px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 486.3 486.3" xmlSpace="preserve" stroke="#475E81">
                                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M395.5,135.8c-5.2-30.9-20.5-59.1-43.9-80.5c-26-23.8-59.8-36.9-95-36.9c-27.2,0-53.7,7.8-76.4,22.5 c-18.9,12.2-34.6,28.7-45.7,48.1c-4.8-0.9-9.8-1.4-14.8-1.4c-42.5,0-77.1,34.6-77.1,77.1c0,5.5,0.6,10.8,1.6,16 C16.7,200.7,0,232.9,0,267.2c0,27.7,10.3,54.6,29.1,75.9c19.3,21.8,44.8,34.7,72,36.2c0.3,0,0.5,0,0.8,0h86 c7.5,0,13.5-6,13.5-13.5s-6-13.5-13.5-13.5h-85.6C61.4,349.8,27,310.9,27,267.1c0-28.3,15.2-54.7,39.7-69 c5.7-3.3,8.1-10.2,5.9-16.4c-2-5.4-3-11.1-3-17.2c0-27.6,22.5-50.1,50.1-50.1c5.9,0,11.7,1,17.1,3c6.6,2.4,13.9-0.6,16.9-6.9 c18.7-39.7,59.1-65.3,103-65.3c59,0,107.7,44.2,113.3,102.8c0.6,6.1,5.2,11,11.2,12c44.5,7.6,78.1,48.7,78.1,95.6 c0,49.7-39.1,92.9-87.3,96.6h-73.7c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h74.2c0.3,0,0.6,0,1,0c30.5-2.2,59-16.2,80.2-39.6 c21.1-23.2,32.6-53,32.6-84C486.2,199.5,447.9,149.6,395.5,135.8z"></path> <path d="M324.2,280c5.3-5.3,5.3-13.8,0-19.1l-71.5-71.5c-2.5-2.5-6-4-9.5-4s-7,1.4-9.5,4l-71.5,71.5c-5.3,5.3-5.3,13.8,0,19.1 c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l48.5-48.5v222.9c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V231.5l48.5,48.5 C310.4,285.3,318.9,285.3,324.2,280z"></path> </g> </g> </g>
                                        </svg>

                                        
                                    </label>
                                    <input
                                        ref={inputRef}
                                        type="file"
                                        accept="image/png, image/jpeg"
                                        hidden
                                        onChange={handleFileChange}
                                    />
                                </div>
                            )
                        }
                        {selectedAvt === 'color' && (
                            <div className="upload-boxv1">
                                <GithubPicker
                                    colors={colors}
                                    color={colorAvt}
                                    triangle="hide"
                                    onChangeComplete={handleChange}
                                />
                            </div>
                        )}
                    </div>
                    <div ref={btnGroupRef} onClick={updateAvatar} className="btn-primary">Change</div>
                </div>
            </Modal>
            <Modal
                title='Change User Name'
                open={isModalChangeName}
                onCancel={handleCancelChangeName}
                className="modal-change-name"
                footer={null}
                width={360}
            >
                <form className="content">
                    <input type="text" 
                        value={tempName}
                        onChange={(e) => setTempName(e.target.value)}
                    />
                    <div onClick={ChangeName} className="btn-primary">Change</div>
                </form>
            </Modal>
        </section>
    )
}
export default Profile